import styled, { css } from 'styled-components';

export const Container = styled.div`
    --password-pointer-size: 15px;
    --password-hint-background: #f1f1f1;
    --password-hint-border: #9297a6;
    --password-hint-border-size: 1px;

    font-size: 12px;
    line-height: 150%;
    z-index: 10;
    position: absolute;
    top: 293px;
    left: 0;
    width: 100%;
    text-align: center;
`;

export const PointerWrapper = styled.div`
    font-size: 0;
    line-height: 0;
`;

export const PointerBorder = styled.div`
    top: var(--password-hint-border-size);
    position: relative;
    display: inline-block;
    width: 0;
    height: 0;
    border-top: none;
    border-bottom: var(--password-pointer-size) solid var(--password-hint-border);
    border-left: var(--password-pointer-size) solid transparent;
    border-right: var(--password-pointer-size) solid transparent;
`;

export const Pointer = styled.div`
    position: absolute;
    left: calc(var(--password-hint-border-size) - var(--password-pointer-size));
    top: var(--password-hint-border-size);
    display: inline-block;
    width: 0;
    height: 0;
    border-top: none;
    border-bottom: calc(var(--password-pointer-size) - var(--password-hint-border-size)) solid
        var(--password-hint-background);
    border-left: calc(var(--password-pointer-size) - var(--password-hint-border-size)) solid transparent;
    border-right: calc(var(--password-pointer-size) - var(--password-hint-border-size)) solid transparent;
`;

export const HintContainer = styled.div`
    text-align: left;
    display: inline-block;
    background: var(--password-hint-background);
    border: var(--password-hint-border-size) solid var(--password-hint-border);
    border-radius: 4px;
    padding: 16px;
`;

export const Hint = styled.div<{ valid?: boolean }>`
    ${({ valid }) =>
        valid &&
        css`
            color: #27ae60;
        `}
`;
